import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { Container, Drawer as DrawerComponent, Grid, IconButton, Divider, Typography, Icon } from '@material-ui/core';
import { CloseIcon, BackBlackIcon } from '../Icons';

const Drawer = ({
  children,
  title,
  classes,
  isBackEnabled,
  onBack,
  onClose,
  fullWidth,
  paperStyles,
  closeIconFirst,
  withoutDivider,
  withoutClose,
  headerClass,
  ...props
}) => {
  const ref = React.useRef();

  React.useEffect(() => {
    if (ref.current && ref.current.children.length > 0) {
      ref.current.children[0].scrollTop = 0;
    }
  }, [children]);

  const fullContentClassName = title ? classes.fullContentWithHeader : classes.fullContent;

  return (
    <DrawerComponent
      anchor="bottom"
      onClose={onClose}
      classes={{
        paperAnchorBottom: fullWidth ? classes.paperAnchorTop : classes.paperAnchorBottom,
        paper: paperStyles || null,
      }}
      {...props}
      ref={ref}
    >
      <Container maxWidth="sm" classes={{ root: fullWidth ? classes.gridContainer : classes.container }}>
        {title && (
          <Fragment>
            <Grid container className={cx(classes.header, closeIconFirst && classes.reverse, headerClass)}>
              {isBackEnabled && (
                <Grid item>
                  <IconButton className={classes.backButton} onClick={onBack} edge="end" data-testid="drawer-back-btn">
                    <Icon component={BackBlackIcon} fontSize="small" />
                  </IconButton>
                </Grid>
              )}
              <Grid item className={classes.title}>
                <Typography variant="h3">{title}</Typography>
              </Grid>
              {!withoutClose && (
                <Grid item>
                  <IconButton onClick={onClose} edge="start" data-testid="drawer-close-btn">
                    <CloseIcon />
                  </IconButton>
                </Grid>
              )}
            </Grid>
            {!withoutDivider && <Divider />}
          </Fragment>
        )}
        <Grid item xs={12} className={fullWidth ? fullContentClassName : classes.content}>
          {children}
        </Grid>
      </Container>
    </DrawerComponent>
  );
};

Drawer.propTypes = {
  children: PropTypes.node,
  title: PropTypes.node,
  classes: PropTypes.objectOf(PropTypes.string),
  onClose: PropTypes.func,
  fullWidth: PropTypes.bool,
  withoutClose: PropTypes.bool,
  headerClass: PropTypes.string,
};

Drawer.defaultProps = {
  children: '',
  title: null,
  fullWidth: false,
  classes: {},
  onClose: () => {},
};

export default Drawer;
